


export default function transformQualifyLeadNames(list, value) {
    if(!list || value) return '';
    return list.find(item => item.value === Number(value))?.nome || ''
}
